import React, { useState } from "react";
import "./AboutUs.css";

import aboutHeroImg from "../../assets/images/about.png";
import leaderImg from "../../assets/images/drMudasir.png";
import bannerImg from "../../assets/images/1st-banner.png";

const AboutUs = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div className="about-page-wrapper">

      {/* =====================================================
          HERO SECTION
      ====================================================== */}

      <section
        className="about-hero-section"
        style={{
          backgroundImage: `
            linear-gradient(
              rgba(0, 0, 0, 0.45),
              rgba(0, 0, 0, 0.45)
            ),
            url(${aboutHeroImg})
          `,
        }}
      >
        <div className="about-hero-content">
          <h1 className="about-title">
            About Us
          </h1>

          <p className="about-subtitle">
            Science-backed Skincare Essentials
          </p>
        </div>
      </section>


      {/* =====================================================
          MAIN CONTENT
      ====================================================== */}

      <main className="about-main-container">

        {/* ===================================================
            ABOUT YOURCARE
        ==================================================== */}

        <section className="about-intro-section">

          <span className="section-label">
            ABOUT YOURCARE
          </span>

          <h2 className="intro-heading">
            At YourCare, we believe exceptional skincare begins
            with exceptional science.
          </h2>

          <div className="intro-body">

            <p>
              Founded by researchers from the Chemistry Research
              Laboratories, National University of Sciences and
              Technology (NUST), Islamabad, our products are
              developed through rigorous scientific research and
              carefully selected natural ingredients.
            </p>

            <p>
              Our flagship Ultimate 4-in-1 Skin Revitalizing Serum
              is the result of 18 months of research, combining
              clinically recognized active ingredients with
              botanical extracts to create skincare that is
              effective, gentle, and suitable for everyday use.
            </p>

            <p>
              We are committed to delivering premium skincare
              formulations that help people achieve healthier,
              brighter, and more youthful-looking skin while
              maintaining the highest standards of quality and
              safety.
            </p>

          </div>

        </section>


        {/* ===================================================
            LEADERSHIP
        ==================================================== */}

        <section className="leadership-section">

          <div className="leadership-grid">

            {/* Leader Image */}

            <div className="leader-image-wrapper">

              <img
                src={leaderImg}
                alt="Dr. Mudassir Iqbal"
                className="leader-img"
              />

            </div>


            {/* Leader Details */}

            <div className="leader-details">

              <span className="section-label">
                LEADERSHIP
              </span>

              <h2 className="leadership-heading">
                Board / CEO / MD Detail Info
              </h2>

              <h3 className="leader-name">
                Dr. Mudassir Iqbal
              </h3>

              <p className="leader-title">
                Professor of Organic Chemistry at NUST Islamabad
              </p>

              <p className="leader-dept">
                School of Natural Sciences
              </p>

              <p className="leader-phone">
                Phone: 5190855575
              </p>

              <a
                href="https://sns.nust.edu.pk/"
                target="_blank"
                rel="noopener noreferrer"
                className="academic-link"
              >
                View Academic Profile →
              </a>


              {/* CEO MESSAGE BUTTON */}

              <div className="ceo-btn-container">

                <p>
                  To view CEO Message, click on the button:
                </p>

                <button
                  type="button"
                  className="btn-ceo-message"
                  onClick={openModal}
                >
                  View CEO Message
                </button>

              </div>

            </div>

          </div>

        </section>


        {/* ===================================================
            PRODUCT BANNER
        ==================================================== */}

        <section className="product-banner-section">

          <div
            className="product-banner-parallax"
            style={{
              backgroundImage: `url(${bannerImg})`,
            }}
            role="img"
            aria-label="YourCare 4 in 1 Serum Banner"
          />

        </section>


        {/* ===================================================
            MISSION & VISION
        ==================================================== */}

        <section className="mission-vision-section">

          {/* Mission */}

          <div className="mv-card">

            <span className="mv-number">
              01
            </span>

            <h3 className="mv-title">
              Our Mission
            </h3>

            <p className="mv-text">
              To develop science-backed skincare products that
              combine innovation, quality, and nature to improve
              skin health and confidence.
            </p>

          </div>


          {/* Vision */}

          <div className="mv-card">

            <span className="mv-number">
              02
            </span>

            <h3 className="mv-title">
              Our Vision
            </h3>

            <p className="mv-text">
              To become Pakistan's leading science-based skincare
              brand recognized for quality, innovation, and trust.
            </p>

          </div>

        </section>

      </main>


      {/* =====================================================
          CEO MESSAGE MODAL
      ====================================================== */}

      {isModalOpen && (

        <div
          className="modal-overlay"
          onClick={closeModal}
        >

          <div
            className="modal-content"
            onClick={(event) => event.stopPropagation()}
          >

            {/* Close Button */}

            <button
              type="button"
              className="modal-close-btn"
              onClick={closeModal}
              aria-label="Close CEO Message"
            >
              &times;
            </button>


            <h2 className="modal-title">
              CEO Message
            </h2>


            <div className="modal-body">

              <h4>
                Welcome to Yourcare
              </h4>

              <p>
                At Yourcare, we believe that personal care should
                be more than a routine—it should be an experience
                built on science, quality, trust, and care. Our
                journey began with a simple vision: to develop
                personal care products that combine scientific
                knowledge with carefully selected ingredients to
                address real skincare and haircare needs. We are
                committed to creating formulations that are
                effective, thoughtful, and suitable for everyday
                use.
              </p>

              <p>
                Our first product, the Yourcare 4-in-1 Skin
                Revitalizing Serum, represents this philosophy.
                It brings together carefully selected ingredients
                to support skin hydration, brightness, antioxidant
                protection, and skin-barrier care in one formulation.
                But this is only the beginning. We are continuously
                working on new formulations, with our face wash and
                haircare range coming soon. Every new product will
                be developed with the same commitment to quality,
                innovation, and customer satisfaction.
              </p>

              <p>
                At Yourcare, we don't believe in simply following
                beauty trends. We believe in understanding the
                science behind healthy skin and hair and translating
                that science into products people can trust.
              </p>

              <p>
                Thank you for becoming part of the Yourcare journey.
              </p>


              <div className="modal-footer-sign">

                <strong>
                  Dr. Mudassir Iqbal
                </strong>

                <p>
                  Founder &amp; CEO, Yourcare
                </p>

              </div>

            </div>

          </div>

        </div>

      )}

    </div>
  );
};

export default AboutUs;